// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type Article48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Article48: FC<Article48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M13.85 34.05H27.6v-3H13.85v3Zm0-8.55h20.3v-3h-20.3v3Zm0-8.55h20.3v-3h-20.3v3ZM9 42c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1V9c0-.8.3-1.5.9-2.1C7.5 6.3 8.2 6 9 6h30c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v30c0 .8-.3 1.5-.9 2.1-.6.6-1.3.9-2.1.9H9Zm0-3h30V9H9v30Z" />
        </svg>
    );
};

export default Article48;
